import React, { HTMLProps } from 'react';

import useStyles from './styles';

interface Props extends Omit<HTMLProps<HTMLAnchorElement>, 'href'> {
    email: string;
}

const EmailLink: React.ForwardRefRenderFunction<HTMLAnchorElement, Props> = ({ email, className, ...props }, ref) => {
    const { classes, cx } = useStyles();
    return (
        <a
            target="_blank"
            rel="nofollow noopener noreferrer"
            {...props}
            href={`mailto:${email}`}
            className={cx(classes.root, className)}
            ref={ref}
        >
            {`✉️${' '}${email}`}
        </a>
    );
};

export default React.forwardRef(EmailLink);
